import { render, staticRenderFns } from "./IconAttrMinimalism.vue?vue&type=template&id=47baeada&scoped=true&"
import script from "./IconAttrMinimalism.vue?vue&type=script&lang=js&"
export * from "./IconAttrMinimalism.vue?vue&type=script&lang=js&"
import style0 from "./IconAttrMinimalism.vue?vue&type=style&index=0&id=47baeada&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47baeada",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ObjectsPublicTheExportNew: require('/web/components/objects/public/TheExportNew.vue').default,TheBlockHeader: require('/web/components/TheBlockHeader.vue').default,AsyncObjectSnippetTooltip: require('/web/components/AsyncObjectSnippetTooltip.vue').default})
